<script type="text/babel">
import Image from '@/components/Panel/Templates/Workspace/Layers/Image/ImageLayer.vue';
import Text from '@/components/Panel/Templates/Workspace/Layers/Text/TextLayer.vue';
import ElementLayer from '@/components/Panel/Templates/Workspace/Layers/Element/ElementLayer.vue';
import RenderedTemplate from '@/components/Panel/Templates/Rendered/RenderedTemplate.vue';
export default {
    name: 'LayersMixin',
    data () {
        return {};
    },
    components: {
        imageLayer: Image,
        textLayer: Text,
        ElementLayer: ElementLayer,
        templateLayer: RenderedTemplate
    }
};

</script>
